function _assert_this_initialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _call_super(_this, derived, args) {
    derived = _get_prototype_of(derived);
    return _possible_constructor_return(_this, _is_native_reflect_construct() ? Reflect.construct(derived, args || [], _get_prototype_of(_this).constructor) : derived.apply(_this, args));
}
function _check_private_redeclaration(obj, privateCollection) {
    if (privateCollection.has(obj)) {
        throw new TypeError("Cannot initialize the same private elements twice on an object");
    }
}
function _class_apply_descriptor_get(receiver, descriptor) {
    if (descriptor.get) {
        return descriptor.get.call(receiver);
    }
    return descriptor.value;
}
function _class_apply_descriptor_set(receiver, descriptor, value) {
    if (descriptor.set) {
        descriptor.set.call(receiver, value);
    } else {
        if (!descriptor.writable) {
            throw new TypeError("attempted to set read only private field");
        }
        descriptor.value = value;
    }
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _class_extract_field_descriptor(receiver, privateMap, action) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to " + action + " private field on non-instance");
    }
    return privateMap.get(receiver);
}
function _class_private_field_get(receiver, privateMap) {
    var descriptor = _class_extract_field_descriptor(receiver, privateMap, "get");
    return _class_apply_descriptor_get(receiver, descriptor);
}
function _class_private_field_init(obj, privateMap, value) {
    _check_private_redeclaration(obj, privateMap);
    privateMap.set(obj, value);
}
function _class_private_field_set(receiver, privateMap, value) {
    var descriptor = _class_extract_field_descriptor(receiver, privateMap, "set");
    _class_apply_descriptor_set(receiver, descriptor, value);
    return value;
}
function _class_private_method_get(receiver, privateSet, fn) {
    if (!privateSet.has(receiver)) {
        throw new TypeError("attempted to get private field on non-instance");
    }
    return fn;
}
function _class_private_method_init(obj, privateSet) {
    _check_private_redeclaration(obj, privateSet);
    privateSet.add(obj);
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _possible_constructor_return(self, call) {
    if (call && (_type_of(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assert_this_initialized(self);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _is_native_reflect_construct() {
    try {
        var result = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (_) {}
    return (_is_native_reflect_construct = function() {
        return !!result;
    })();
}
import { merge } from "lodash";
var pkg = {
    name: '@wahlandcase/attuned-charts',
    version: '1.0.4'
};
var Singleton = function Singleton() {
    "use strict";
    _class_call_check(this, Singleton);
};
_define_property(Singleton, "_instance", null);
var _didInit = /*#__PURE__*/ new WeakMap(), _init = /*#__PURE__*/ new WeakSet(), _remove = /*#__PURE__*/ new WeakSet();
var AttunedDebugInspector = /*#__PURE__*/ function(Singleton) {
    "use strict";
    _inherits(AttunedDebugInspector, Singleton);
    function AttunedDebugInspector() {
        _class_call_check(this, AttunedDebugInspector);
        var _this;
        _this = _call_super(this, AttunedDebugInspector), _class_private_method_init(_this, _init), _class_private_method_init(_this, _remove), _class_private_field_init(_this, _didInit, {
            writable: true,
            value: false
        }), _define_property(_this, "moduleName", pkg.name), _define_property(_this, "moduleVersion", pkg.version);
        if (AttunedDebugInspector._instance) return _possible_constructor_return(_this, _this.instance);
        _class_private_method_get(_this, _init, init).call(_this);
        AttunedDebugInspector._instance = _this;
        return _this;
    }
    _create_class(AttunedDebugInspector, [
        {
            key: "instance",
            get: function get() {
                return AttunedDebugInspector._instance;
            }
        },
        {
            key: "appendMeta",
            value: function appendMeta(name, data) {
                if (!name || !data) return;
                if (!window._att_dev || !window._att_dev[this.moduleName]) return;
                merge(window._att_dev[this.moduleName].meta, _define_property({}, name, data));
            }
        },
        {
            key: "createHelper",
            value: function createHelper(name, cb) {
                if (!name || !cb) return;
                if (!window._att_dev || !window._att_dev[this.moduleName]) return;
                merge(window._att_dev[this.moduleName].helpers, _define_property({}, name, cb));
            }
        },
        {
            key: "removeMeta",
            value: function removeMeta(name) {
                _class_private_method_get(this, _remove, remove).call(this, name, 'meta');
            }
        },
        {
            key: "removeHelper",
            value: function removeHelper(name) {
                _class_private_method_get(this, _remove, remove).call(this, name, 'helpers');
            }
        }
    ]);
    return AttunedDebugInspector;
}(Singleton);
function init() {
    if (_class_private_field_get(this, _didInit)) return;
    window._att_version = merge({}, window._att_version, _define_property({}, this.moduleName, this.moduleVersion));
    window._att_dev = merge({}, window._att_dev, _define_property({}, this.moduleName, {
        helpers: {},
        meta: {}
    }));
    _class_private_field_set(this, _didInit, true);
}
function remove(name, type) {
    if (!name || !type) return;
    if (!window._att_dev || !window._att_dev[this.moduleName]) return;
    delete window._att_dev[this.moduleName][type][name];
}
var DebugInspector = new AttunedDebugInspector();
export { DebugInspector };

//# sourceMappingURL=DebugInspector.js.map